var exports = {
  "r": "removedParentIssuesList__G2ipGt",
  "v": "removedParentIssueItem__gO-39K",
};

module.exports = exports;
